var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFullscreen = function SvgFullscreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 10H1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1Zm-1 8H2v-6h6v6ZM19.92.62a1 1 0 0 0-.54-.54A1 1 0 0 0 19 0h-6a1 1 0 1 0 0 2h3.59l-5.3 5.29a1 1 0 0 0 .325 1.639 1 1 0 0 0 1.095-.219L18 3.41V7a1 1 0 0 0 2 0V1a1.001 1.001 0 0 0-.08-.38Z"
  })));
};
export default SvgFullscreen;